// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_3p-7";
export var adjustableWidthBorderHeld = "_3p-8";
export var arrow = "_3p-3";
export var arrowButton = "_3p-4";
export var headerCell = "_3p-0";
export var help = "_3p-2";
export var icon = "_3p-1";
export var iconWrapper = "_3p-6";
export var noBorder = "_3p-b";
export var nonAdjustableWidthBorder = "_3p-9";
export var nonAdjustableWidthBorderHeld = "_3p-a";
export var textButton = "_3p-5";